import React from 'react'

import { type StepComponentProps } from '../types'
import { NoPlansStateDirections } from './NoPlansStateDirections'
import { OffThatchMedicalPlanDetails } from './OffThatchMedicalPlanDetails'

type NoPlansAvailableRouterProps = StepComponentProps & {
  existingPlan?: boolean
}

export function NoPlansAvailableRouter (props: NoPlansAvailableRouterProps) {
  const [showPlanDetails, setShowPlanDetails] = React.useState(props.existingPlan)

  if (showPlanDetails) {
    return <OffThatchMedicalPlanDetails {...props} setShowPlanDetails={setShowPlanDetails} />
  }

  return <NoPlansStateDirections {...props} onContinue={() => setShowPlanDetails(true)} />
}
